import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from '../../utils/auth'

export default (store) => ({
  path: 'all-product-analytics',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const AllProductSalesAnalyticsContainer = require('./containers/AllProductSalesAnalytics').default;
      const reducer = require('./modules/allProductSalesAnalytics').reducer;
      let homeReducers = require('../Home/modules/home');
      const {loadBillFieldsReducer} = require('../SalesForecasts/modules/salesForecasts');
      const {loadStoreOptionsReducer, loadStoreTagOptionsReducer} = require('../SalesAnalytics/modules/salesAnalytics');
      /*  Add the reducer to the store on key 'counter'  */
      const filterValuesReducer = homeReducers.filterValuesReducer;
      injectReducer(store, {key: 'allProductSalesAnalytics', reducer: reducer});
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer});
      injectReducer(store, {key: 'storeTagOptions', reducer: loadStoreTagOptionsReducer})
      injectReducer(store, {key: 'filter', reducer: filterValuesReducer});
      injectReducer(store, {key: 'billFields', reducer: loadBillFieldsReducer});
      /*  Return getComponent   */
      cb(null, AllProductSalesAnalyticsContainer)

      /* Webpack named bundle   */
    }, 'allProductSalesAnalytics')
  }
})



// WEBPACK FOOTER //
// ./src/routes/AllProductSalesAnalytics/index.js